import { queryOptions } from "@tanstack/react-query"

import { sharedConfig } from "~/lib/config/shared"

type VersionResponse = {
  version: string
}

/**
 * Query key factory for version operations
 */
export const versionQueryKeys = {
  version: () => ["version"] as const,
} as const

/**
 * Get app version from server
 */
export const getVersionQueryOptions = () =>
  queryOptions({
    queryKey: versionQueryKeys.version(),
    queryFn: async (): Promise<VersionResponse> => {
      const response = await fetch("/version")

      if (!response.ok) {
        throw new Error("Failed to fetch version")
      }

      const json = (await response.json()) as { data: VersionResponse }

      return json.data
    },
    refetchInterval: sharedConfig.flags.versionCheckEnabled
      ? sharedConfig.versionCheckInterval
      : false,
    enabled: sharedConfig.flags.versionCheckEnabled,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
  })
